export default function StepItem({ step }) {
  const { id, title, content } = step;

  // Split title on " | " to get prefix and main title
  const [prefix, mainTitle] = title.includes(' | ') 
    ? title.split(' | ', 2) 
    : ['', title];

  return (
    <div className="step-item">
      {prefix && (
        <div className="step-item__prefix">{prefix}</div>
      )}
      <h3 className="step-item__title">{mainTitle}</h3>
      {content && (
        <div 
          className="step-item__content"
          dangerouslySetInnerHTML={{ __html: content }}
        />
      )}
    </div>
  );
}

